import React, { useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import SideBar from "./components/shared/SideBar";
import Header from "./components/shared/Header";
import "bulma/css/bulma.css";
import Dashboard from "./features/dashboard/Dashboard";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import FeedbackView from "./features/feedbacks/View";
import ReviewView from "./features/feedbacks/ReviewView";
import FeedbacksPage from "./features/feedbacks/Page";
import AnalyticsView from "./features/analytics/AnalyticsView";
import ChatIndex from "./features/feedbacks/ChatIndex";
import ChatView from "./features/feedbacks/ChatView";
import UserView from "./features/feedbacks/UserView";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import CourseView from "./features/courses/CourseView";
import ProtectedRoute from "./components/shared/ProtectedRoute";
import Login from "./features/auth/Login";
import ForceDocminer from "./features/courses/ForceDocminer";
import DatasetMonitoring from "./features/datasets/DatasetMonitoring";

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setIsSidebarOpen(false);

  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <div className="App">
                    <Header toggleSidebar={toggleSidebar} />
                    <div className="columns mt-3 is-gapless">
                      <SideBar
                        isOpen={isSidebarOpen}
                        closeSidebar={closeSidebar}
                      />
                      <main className="column" onClick={closeSidebar}>
                        <Routes>
                          <Route path="dashboard" element={<Dashboard />} />
                          <Route path="chats" element={<ChatIndex />} />
                          <Route path="chats/:id" element={<ChatView />} />
                          <Route path="feedbacks" element={<FeedbacksPage />} />
                          <Route
                            path="feedbacks/:id"
                            element={<FeedbackView />}
                          />
                          <Route path="reviews/:id" element={<ReviewView />} />
                          <Route path="analytics" element={<AnalyticsView />} />
                          <Route
                            path="dataset-monitoring"
                            element={<DatasetMonitoring />}
                          />
                          <Route path="course/:id" element={<CourseView />} />
                          <Route path="user/:id" element={<UserView />} />
                          <Route path="docminer" element={<ForceDocminer />} />
                          <Route
                            path="force-docminer/:id"
                            element={<ForceDocminer />}
                          />
                          {/* Redirect to dashboard if no path matches */}
                          <Route
                            path=""
                            element={<Navigate to="/dashboard" replace />}
                          />
                        </Routes>
                      </main>
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
